import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Row, Col, Button, ListGroup, ListGroupItem, FormGroup } from 'reactstrap';
import { AppName } from '../App.js';
import { Title } from './Title.js';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faSearch } from '@fortawesome/free-solid-svg-icons';

export const Home = (props) => {
    const { Access, LoginMessage } = props;
    const [redirect, setRedirect] = useState('');

    //useEffect(() => {
    //}, [props.CurrentUser]);

    return (
        <div>
            <Title subtitle="Home" />
            {redirect ? <Redirect to={redirect} /> : null}
            <Row>
                <Col lg="8" className=" text-center text-md-start">
                    <div className="border-secondary pb-0 mb-2" style={{ borderBottomWidth: 2, borderBottomStyle: 'solid' }}>
                        <h3 className="d-none d-sm-inline-block d-md-none">{AppName}</h3>
                        <h2 className="d-inline-block d-sm-none d-md-inline-block">{AppName}</h2>
                    </div>
                </Col>
            </Row>

        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Home.js